import Typography, { TypographyProps } from '@mui/material/Typography';
import React, { FC } from 'react';
import useTheme from '@mui/styles/useTheme';

export const SectionTitle: FC<TypographyProps> = ({ sx, ...props }) => {
  const theme = useTheme();

  return <Typography variant="h4" sx={{ mb: theme.spacing(1), fontWeight: 500, ...sx }} {...props} />;
};
